import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical, Star } from 'lucide-react';
import { vehiclesAPI } from '../services/api';
import { useT } from '../services/i18n';
import { prodName } from '../services/catalogI18n';
import { energyLabel } from '../services/fuel';
import FuelBadge from './FuelBadge';

const eur = (n) => `${Number(n || 0).toFixed(2)} €`;

// « Additifs recommandés » in Mon garage: additives / cleaners matching each vehicle's energy
export const GarageAdditivesCard = ({ vehiclesCount }) => {
  const { t, lang } = useT();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!vehiclesCount) { setData(null); return; }
    vehiclesAPI.garageAdditives().then(setData).catch(() => setData({ vehicles: [] }));
  }, [vehiclesCount]);
  if (!vehiclesCount || !data) return null;
  const vehicles = (data.vehicles || []).filter(v => v.items?.length);
  return (
    <section className="border border-amber-200 bg-amber-50/40 rounded-lg p-4 mb-4" data-testid="garage-additives">
      <h3 className="font-semibold text-gray-900 flex items-center gap-2"><FlaskConical size={18} className="text-amber-600" /> {t('garage.additivesTitle')}</h3>
      <p className="text-xs text-gray-500 mt-0.5 mb-3">{t('garage.additivesHint')}</p>
      {vehicles.length === 0 ? <p className="text-xs text-gray-500" data-testid="garage-additives-empty">{t('garage.additivesEmpty')}</p> : vehicles.map(v => (
        <div key={v.vehicle_id} className="mb-3 last:mb-0" data-testid={`garage-additives-vehicle-${v.vehicle_id}`}>
          <p className="text-sm font-medium text-gray-800">{v.label || `${v.brand} ${v.model}`}{v.engine ? <span className="text-gray-500 font-normal"> · {v.engine}</span> : null}{v.energy ? <span className="ml-2 text-[11px] font-semibold uppercase tracking-wide text-amber-700">{energyLabel(t, v.energy)}</span> : null}</p>
          <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {v.items.map(p => (
              <li key={p.id} className="bg-white border border-gray-200 rounded-lg p-2 flex gap-2" data-testid={`garage-additive-${v.vehicle_id}-${p.id}`}>
                <Link to={`/produit/${p.slug || p.id}`} className="shrink-0"><img src={p.image} alt="" className="w-14 h-14 object-contain" /></Link>
                <div className="min-w-0 flex-1">
                  <Link to={`/produit/${p.slug || p.id}`} className="text-xs font-medium text-gray-900 hover:text-orange-600 line-clamp-2">{p.brand} {prodName(p, lang)}</Link>
                  <p className="text-[11px] text-gray-500 truncate">{p.subcategory}</p>
                  <div className="flex items-center justify-between gap-2 mt-1">
                    <span className="text-sm font-bold text-gray-900">{eur(p.price)}</span>
                    {p.rating > 0 && <span className="text-[11px] text-amber-600 inline-flex items-center gap-0.5"><Star size={11} className="fill-amber-400 text-amber-400" /> {Number(p.rating).toFixed(1)}</span>}
                  </div>
                  <FuelBadge types={p.fuel_types} testId={`garage-additive-fuel-${p.id}`} />
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
};

export default GarageAdditivesCard;
